import { styled } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { Menu } from '@mui/icons-material';
import { theme } from '@theme/index';

export const Styles = {
  NavbarContainer: styled('div')(({ theme }) => ({
    position: 'relative',
    width: '100%',
    height: '50px',
    backgroundColor: '#2a7221',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      height: 'auto',
      padding: '10px 0'
    }
  })),

  NavbarInner: styled('div')(({ theme }) => ({
    maxWidth: '1200px',
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'flex-start'
    }
  })),

  MobileMenuItem: styled('li')(({ theme }) => ({
    width: '100%',
    padding: '15px 20px',
    borderBottom: '1px solid #04682E',
    '&:last-child': {
      borderBottom: 'none'
    }
  })),

  MobileSearchContainer: styled('div')(({ theme }) => ({
    padding: '15px',
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    gap: '10px'
  })),

  MobileMenu: styled('div')({
    width: '100%',
    display: 'flex',
    flexDirection: 'column'
  }),

  NavbarList: styled('ul')<{ isMobile: boolean; isOpen: boolean }>(
    ({ theme, isMobile, isOpen }) => ({
      display: 'flex',
      height: '50px',
      listStyle: 'none',
      alignItems: 'center',
      padding: 0,
      margin: 0,
      [theme.breakpoints.down('md')]: {
        display: isOpen ? 'flex' : 'none',
        flexDirection: 'column',
        height: 'auto',
        width: '100%',
        position: 'absolute',
        top: '100%',
        left: 0,
        backgroundColor: '#105330',
        zIndex: 1000,
        padding: isOpen ? '15px 0' : 0
      }
    })
  ),

  NavbarItem: styled('li')(({ theme }) => ({
    padding: '0 25px',
    height: '50px',
    display: 'flex',
    alignItems: 'center',
    borderRight: '1px solid transparent',
    borderImage: 'linear-gradient(to bottom, #04682E, #ffffff, #04682E)',
    borderImageSlice: 1,
    '&:first-child': {
      borderLeft: '1px solid transparent'
    },
    [theme.breakpoints.down('md')]: {
      width: '100%',
      padding: '10px 20px !important',
      borderRight: 'none',
      borderBottom: '1px solid #04682E'
    }
  })),

  NavbarLink: styled('a')({
    textDecoration: 'none',
    color: '#ffffffff',
    fontSize: '13.5px',
    fontWeight: 'bold',
    '&:hover': {
      color: '#000000ff'
    }
  }),

  SearchInput: styled('input')(({ theme }) => ({
    width: '358px',
    height: '30px',
    backgroundColor: '#d9d9d9',
    border: 'none',
    paddingLeft: '10px',
    fontSize: '14px',
    color: '#000000',
    borderRadius: '4px',
    fontWeight: '500',
    [theme.breakpoints.down('md')]: {
      width: '200px',
      margin: '10px 0'
    },
    '&::placeholder': {
      color: '#000000',
      fontWeight: '700'
    }
  })),

  SearchContainer: styled('div')({
    display: 'flex',
    alignItems: 'center'
  }),

  IconButton: styled('div')({
    width: '33px',
    height: '35px',
    marginLeft: '10px',
    backgroundColor: '#ffffff',
    boxShadow: '0px 0px 8px rgba(0, 0, 0, 0.3)',
    borderRadius: '13.5px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    position: 'relative',
    top: '1px'
  }),

  Icon: styled(SearchIcon)({
    fontSize: '20px',
    color: '#000000',
    height: '80px'
  }),
  MobileMenuButton: styled(Menu)(({ theme }) => ({
    color: 'white',
    fontSize: '32px',
    marginLeft: '15px',
    cursor: 'pointer',
    display: 'none',
    [theme.breakpoints.down('md')]: {
      display: 'block'
    }
  })),

  NavbarSectionTitle: styled('div')({
    padding: '10px 20px',
    backgroundColor: '#000000',
    color: '#FFFFFF',
    fontWeight: 'bold',
    fontSize: '15px',
    marginBottom: '5px'
  }),

  NavbarSection: styled('div')({
    width: '100%',
    marginBottom: '15px'
  })
};
